import { Component, OnInit, ChangeDetectorRef, ElementRef, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { delay, first } from 'rxjs/operators';
import { Select, Store } from '@ngxs/store';
import { Observable } from 'rxjs';

import * as Models from '../../../../../../src/app/models/commonModels';
import { FormBaseComponent } from '../../../../../../src/app/shared/components/form/form.component';
import { AuthenticationService } from '../../../../../../src/app/shared/services/authentication.service';
import { EnvironmentService } from '../../../../../../src/app/services/environment.service';
import { HelperService } from "../../../../../../src/app/services/helper/helper.service";
import { BannerService } from '../../../../../../src/app/shared/services/banner.service';



import { AldAnonymousState } from "../../../../../../src/app/services/ald-anonymous/ald-anonymous.state";
import * as AldAnonymousActions from "../../../../../../src/app/services/ald-anonymous/ald-anonymous.action";
import * as GarageVisitsModels from '../../../../../../src/app/models/garage-visits/garage-visits';
import * as GarageModels from '../../../../../../src/app/models/garage/garage';
import * as CarModels from "../../../../../../src/app/models/car/car";
import * as CarTypeModels from '../../../../../../src/app/models/car/carType';

import * as TyreParametersModels from '../../../../../../src/app/models/tyre/tyreParameters';

@Component({
    selector: 'app-garage-visit',
  templateUrl: './garage-visit.component.html',
  styleUrls: ['./garage-visit.component.scss']
})

export class GarageVisitComponent extends FormBaseComponent implements OnInit {

  @ViewChild('CarType') divCarType: ElementRef;

  @ViewChild('Heder') divHeder: ElementRef;


  public formMain: FormGroup;

  public IsEmailValid: boolean = false;

  public IsTelephoneValid: boolean = false;

  public currentStep: number = 0;


  public requestGarageVisitSave: Models.Request<GarageVisitsModels.GarageVisitModel> = new Models.Request<GarageVisitsModels.GarageVisitModel>();

  public currentGarage: GarageModels.GaragePreviewModel;

  public garageVisits: GarageVisitsModels.GarageVisitModel[];

  public garageVisitsSearch: GarageVisitsModels.GarageVisitsSearchModel = new GarageVisitsModels.GarageVisitsSearchModel();

  public garageVisitPlaceList: GarageVisitsModels.GarageVisitsPlaceListModel;

  public garageVisitsPlaceSearch: GarageVisitsModels.GarageVisitsPlaceSearch = new GarageVisitsModels.GarageVisitsPlaceSearch();

  public garageRequest: Models.RequestModel;

  public carCheckRequest: Models.Request<string> = new Models.Request<string>();

  public slectedDate: Date = new Date();

  public currentDate: Date = new Date();

  public currentDateId: number;

  public selectedMonth: Date = new Date();

  public timeSlots: GarageVisitsModels.GarageVisitsTimeSlotModel[] = null;

  public now: Date = new Date();

  public isDialogDisplayAddNewVisit: boolean = false;

  public isDialogDisplayEditVisit: boolean = false;

  public visitTimeSlot: GarageVisitsModels.GarageVisitsTimeSlotModel;

  public visitGarageVisitPlace: GarageVisitsModels.GarageVisitsPlaceModel;

  public blockedDayList: GarageVisitsModels.GarageBlockedModel[];

  public searchDays: GarageVisitsModels.GarageBlockedHourSearch = new GarageVisitsModels.GarageBlockedHourSearch();

  public newGarageVisit: GarageVisitsModels.GarageVisitModel = new GarageVisitsModels.GarageVisitModel();

  public garageId: number;

  public carTypes: CarTypeModels.CarTypeModel[];

  public visitTyreSources: GarageVisitsModels.VisitTyreSourceModel[];

  public carCheck: GarageVisitsModels.CarCheckModel;

  public displayMissingCarType: boolean = false;

  public displayInvalidCarType: boolean = false;

  public diameters: TyreParametersModels.TyreDiameterModel[];

  @Select(AldAnonymousState.GagareVisitsList)
  GagareVisitsList$: Observable<Models.ResponseList<GarageVisitsModels.GarageVisitModel>>;

  @Select(AldAnonymousState.GarageVisitsPlaceList)
  GarageVisitsPlaceList$: Observable<GarageVisitsModels.GarageVisitsPlaceListModel>;

  @Select(AldAnonymousState.GarageVisit)
  GarageVisit$: Observable<Models.Response<GarageVisitsModels.GarageVisitModel>>;

  @Select(AldAnonymousState.GarageBlockedDayList)
  GarageBlockedDayList$: Observable<GarageVisitsModels.GarageBlockedListModel>;

  @Select(AldAnonymousState.GaragePreview)
  GaragePreview$: Observable<Models.Response<GarageModels.GaragePreviewModel>>;

  @Select(AldAnonymousState.CarTypes)
  CarTypes$: Observable<CarTypeModels.CarTypeListModel>;

  @Select(AldAnonymousState.CarCheck)
  CarCheck$: Observable<Models.Response<GarageVisitsModels.CarCheckModel>>;

  @Select(AldAnonymousState.VisitTyreSources)
  VisitTyreSources$: Observable<Models.ResponseList<GarageVisitsModels.VisitTyreSourceModel>>;

  @Select(AldAnonymousState.TyreDiameterList)
  TyreDiameterList$: Observable<Models.ResponseList<TyreParametersModels.TyreDiameterModel>>;
  get inputFirstName(): any {
    return this.formMain.get('inputFirstName');
  }

  get inputLastName(): any {
    return this.formMain.get('inputLastName');
  }

  get inputPhoneNr(): any {
    return this.formMain.get('inputPhoneNr');
  }

  get inputMail(): any {
    return this.formMain.get('inputMail');
  }

  get inputRegistrationNumber(): any {
    return this.formMain.get('inputRegistrationNumber');
  }

  get inputCarWmakesName(): any {
    return this.formMain.get('inputCarWmakesName');
  }

  get inputCarWmodelName(): any {
    return this.formMain.get('inputCarWmodelName');
  }


  constructor(
        private formBuilder: FormBuilder,
        public router: Router,
        public authenticationService: AuthenticationService,
        public store: Store,
        public helperService: HelperService,
        public environmentService: EnvironmentService,
        public changeDetectorRef: ChangeDetectorRef,
        public activatedRoute: ActivatedRoute,
        public bannerService: BannerService
    ) {

    super(helperService, environmentService, changeDetectorRef);

      this.garageVisitsSearch.IsPagination = false;

      this.garageVisitsPlaceSearch.IsPagination = false;

    this.garageVisitsPlaceSearch.IsActive = true;

    }

  ngOnInit() {

    this.formMain = this.formBuilder.group({
      inputFirstName: ['', [Validators.required, Validators.maxLength(30), Validators.minLength(3)]],
      inputLastName: ['', [Validators.required, Validators.maxLength(50), Validators.minLength(3)]],
      inputPhoneNr: ['', Validators.required],
      inputMail: ['', Validators.required],
      inputRegistrationNumber: ['', [Validators.required, Validators.maxLength(7), Validators.minLength(4)]],
      inputCarWmakesName: ['', Validators.required],
      inputCarWmodelName: ['', Validators.required],
    });

    this.subscription.add(this.CarCheck$.subscribe((data) => {

      if (data && data.RequestSignature == this.carCheckRequest.RequestSignature) {
        if (data.Success) {

          if (data.Item.IsCustomerCar) {
            this.carCheck = data.Item;
            this.carCheckRequest.End();
          }
          else {
            this.onSaveNewVisit();
            this.carCheckRequest.End();
          }
        }
      }
    }));

    this.subscription.add(this.GaragePreview$.subscribe((data) => {

      if (data && data.Success && this.garageRequest && data.RequestSignature == this.garageRequest.RequestSignature) {

        this.currentGarage = data.Item;

        this.now.setDate(this.now.getDate() + this.currentGarage.CustomerVisitDelayDays);

        this.getGarageVisitsPlace();

        this.getGarageBlockedDays();

        this.getGarageVisits(this.currentDate);
        }
    }));

    this.subscription.add(this.CarTypes$.subscribe((data) => {
      if (data && data.Success) {
        this.carTypes = data.Items;
      }
    }));

    this.subscription.add(this.VisitTyreSources$.subscribe((data) => {
      if (data && data.Success) {
        this.visitTyreSources = data.Items;
      }
    }));

    this.subscription.add(this.GarageVisit$.subscribe((data) => {
      if (data && data.RequestSignature == this.requestGarageVisitSave.RequestSignature) {

        if (data.Success) {
          this.router.navigate(['/garage-visit-confirmation', data.Item.GarageVisitId]);
        }
        else {
          this.requestGarageVisitSave.End();
          this.carCheck = null;
        }
      }
    }));

    this.subscription.add(this.GagareVisitsList$.subscribe((data) => {
      if (data && data.Success && data.RequestSignature == this.garageVisitsSearch.RequestSignature) {
        this.garageVisits = data.Items;
      }
    }));

    this.subscription.add(this.GarageBlockedDayList$.subscribe((result) => {
      if (result && result.Success == true && result.RequestSignature == this.searchDays.RequestSignature) {
        this.blockedDayList = result.Items;
        this.searchDays.End();
      }
    }));

    this.subscription.add(this.GarageVisitsPlaceList$.subscribe((ret) => {
      if (ret && ret.RequestSignature === this.garageVisitsPlaceSearch.RequestSignature) {
        this.garageVisitPlaceList = ret;

        this.garageVisitPlaceList.Items = this.garageVisitPlaceList.Items.filter(p => p.IsActive);

        this.timeSlots = new Array<GarageVisitsModels.GarageVisitsTimeSlotModel>();

        if (this.garageVisitPlaceList.Success && this.garageVisitPlaceList.Items) {

          this.garageVisitPlaceList.Items.forEach(p => {


            p.PlaceTimeSlot.forEach(t => {

              if (!this.timeSlots.some(ts => ts.Id == t.TimeSlot.Id)) {
                this.timeSlots.push(t.TimeSlot);
              }
            }
            )
          });

          this.timeSlots = this.timeSlots.sort((a, b) => (a.Id > b.Id) ? 1 : -1);
        }
      }
    }));

    this.store.dispatch([new AldAnonymousActions.GetCarTypes(), new AldAnonymousActions.GetVisitTyreSources(), new AldAnonymousActions.GetTyreDiameterList()]);

    this.subscription.add(this.TyreDiameterList$.subscribe((data) => { if (data) { this.diameters = data.Items.filter(d => d.IsGarageVisitAvailable == true); } }));

    this.activatedRoute.paramMap.subscribe(params => {
      this.garageId = +params.get('id');

      if (this.garageId && !this.currentGarage) {

        this.garageRequest = new Models.RequestModel(this.garageId);

        this.store.dispatch(new AldAnonymousActions.GaragePreviewGet(this.garageRequest));
      }
    });

    this.garageVisitsSearch.DateFrom = new Date(this.currentDate.getFullYear(), this.currentDate.getMonth(), 1, 0, 0);

    this.garageVisitsSearch.DateTo = new Date(this.garageVisitsSearch.DateFrom.setMonth(this.currentDate.getMonth() + 3));
  }

  public IsFormValid(): boolean {
    return this.IsEmailValid &&
      this.IsTelephoneValid &&
      this.formMain.valid &&
      this.newGarageVisit.IsAldConsent &&
      (this.newGarageVisit.VisitTyreSourceId != null) &&
      ((this.newGarageVisit.CarTypeId == 1 && this.newGarageVisit.TyreDiameter != null) || (this.newGarageVisit.CarTypeId != 1))
      ;
  }

  public onSaveNewVisit() {

    this.carCheck = null;

    this.newGarageVisit.TyreId = null;
    this.newGarageVisit.TyreName = null;
    this.newGarageVisit.TyreFromOrderId = null;
    this.newGarageVisit.TyreFromDepositeId = null;
    this.newGarageVisit.GarageId = this.currentGarage.GarageId;

    this.requestGarageVisitSave.Begin();
    this.requestGarageVisitSave.Item = this.newGarageVisit;


    this.store.dispatch(new AldAnonymousActions.GarageVisitCreate(this.requestGarageVisitSave));
  }

  public onCarCheck() {

    this.carCheckRequest.Item = this.newGarageVisit.RegistrationNumber;
    this.carCheckRequest.Begin();

    this.store.dispatch(new AldAnonymousActions.CheckCar(this.carCheckRequest));
  }

  public onValidationEmail(error: boolean) {

    this.IsEmailValid = !error;
  }

  public onValidationTelephone(error: boolean) {

    this.IsTelephoneValid = !error;
  }

  public onSelect($event: any) {

    this.currentDate.setHours(2);

    this.currentDateId = this.GetDateIdFromDate(this.currentDate);

    this.getGarageVisitsPlace();
  }

  public onMonthChange(monthSelected) {

    this.selectedMonth = new Date(monthSelected.year, monthSelected.month - 1, 1);

    this.getGarageVisits(this.selectedMonth);
  }

  public getGarageVisits(GivenDate: Date) {

    this.garageVisitsSearch.DateFrom = new Date(GivenDate.getFullYear(), GivenDate.getMonth(), 1, 0, 0);
    this.garageVisitsSearch.DateTo = new Date(this.garageVisitsSearch.DateTo.setMonth(GivenDate.getMonth() + 3));
    this.garageVisitsSearch.GarageId = this.currentGarage.GarageId;

    this.store.dispatch(new AldAnonymousActions.GetGarageVisitList(this.garageVisitsSearch));
  }

  public getCarVisitCount(GivenDate: any): number {



    let result = 0;

    let dateId = this.GetDateId(GivenDate);

    if (this.garageVisits) {

      result = this.garageVisits.filter(gv => gv.DateId == dateId).length;
    }

    return result;
  }

  public GetDateId(GivenDate: any): number {

    var year: number = GivenDate.year * 10000;

    var month: number = (GivenDate.month + 1) * 100;

    var day: number = GivenDate.day;

    return year + month + day;

  }

  public GetDateIdFromDate(GivenDate: Date): number {

    var year: number = GivenDate.getFullYear() * 10000;

    var month: number = (GivenDate.getMonth() + 1) * 100;

    var day: number = GivenDate.getDate();

    return year + month + day;

  }

  public getGarageVisitsPlace() {

    this.garageVisitsPlaceSearch.Date = this.currentDate;
    this.garageVisitsPlaceSearch.DateId = this.GetDateIdFromDate(this.currentDate);
    this.garageVisitsPlaceSearch.GarageId = this.currentGarage.GarageId;

    this.store.dispatch(new AldAnonymousActions.GetGarageVisitPlaceList(this.garageVisitsPlaceSearch));
  }

  public getGarageBlockedDays() {

    this.searchDays.IsPagination = false;

    this.searchDays.GarageId = this.currentGarage.GarageId;

    this.store.dispatch(new AldAnonymousActions.GetGarageBlockedDaysList(this.searchDays));
  }

  public SetTimeSlotStyles(TimeSlot: GarageVisitsModels.GarageVisitsTimeSlotModel, GarageVisitPlace: GarageVisitsModels.GarageVisitsPlaceModel): object {

    let retur: object = null;

    if (!GarageVisitPlace.PlaceTimeSlot.some(ts => ts.TimeSlot.Id == TimeSlot.Id)) {
      retur = { 'opacity': '0' };
    }
    else if (!this.IsTimeSlotFree(TimeSlot, GarageVisitPlace)) {

      let garageVisit: GarageVisitsModels.GarageVisitModel = this.GetGarageVisit(TimeSlot, GarageVisitPlace);

      retur = { 'background': '#0091D5', 'color': '#000' };

    }
    else if (this.helperService.GetDateId(this.currentDate) < this.helperService.GetDateId(this.now) || TimeSlot.IsBlocked) {
      retur = { 'opacity': '0.4' };
    }

    return retur;
  }

  public IsCarPlace(GarageVisitPlace: GarageVisitsModels.GarageVisitsPlaceModel): boolean {

    return GarageVisitPlace.IsEnableCar && !GarageVisitPlace.IsEnableTruck;
  }

  public IsTrackPlace(GarageVisitPlace: GarageVisitsModels.GarageVisitsPlaceModel): boolean {

    return GarageVisitPlace.IsEnableTruck;
  }

  public IsGarageOpen(): boolean {
    return this.garageVisitPlaceList.Items.reduce((pn, u) => [...pn, ...u.PlaceTimeSlot], []).length > 0;
  }

  public GarageVisitPlaceOnlineCount(): number {
    return this.garageVisitPlaceList.Items.filter(p => p.IsEnableOnline === true).length;
  }

  public GarageVisitPlaceOfflineCount(): number {
    return this.garageVisitPlaceList.Items.filter(p => p.IsEnableOnline === false).length;
  }

  public GarageVisitPlaceOnline(): GarageVisitsModels.GarageVisitsPlaceModel[] {
    return this.garageVisitPlaceList.Items.filter(p => p.IsEnableOnline === true).sort((a, b) => (a.Name > b.Name) ? 1 : -1);
  }

  public GarageVisitPlaceOffline(): GarageVisitsModels.GarageVisitsPlaceModel[] {
    return this.garageVisitPlaceList.Items.filter(p => p.IsEnableOnline === false).sort((a, b) => (a.Name > b.Name) ? 1 : -1);
  }

  public IsTimeSlotFree(TimeSlot: GarageVisitsModels.GarageVisitsTimeSlotModel, GarageVisitPlace: GarageVisitsModels.GarageVisitsPlaceModel): boolean {

    return !this.garageVisits.some(gv => gv.TimeSlotId == TimeSlot.Id && gv.GaragePlaceId == GarageVisitPlace.GaragePlaceId && gv.DateId == this.helperService.GetDateId(this.currentDate));

  }

  public IsTimeSlotDisplay(TimeSlot: GarageVisitsModels.GarageVisitsTimeSlotModel, GarageVisitPlace: GarageVisitsModels.GarageVisitsPlaceModel): boolean {

    let isFree = this.IsTimeSlotFree(TimeSlot, GarageVisitPlace);

    if (isFree) {
      return true;
    }
    else {
      let garageVisit: GarageVisitsModels.GarageVisitModel = this.GetGarageVisit(TimeSlot, GarageVisitPlace);

      if (garageVisit && garageVisit.BaseGarageVisitId) {
        return false;
      }
      else {
        return true;
      }
    }
  }

  public GetGarageVisit(TimeSlot: GarageVisitsModels.GarageVisitsTimeSlotModel, GarageVisitPlace: GarageVisitsModels.GarageVisitsPlaceModel): GarageVisitsModels.GarageVisitModel {

    if (!this.IsTimeSlotFree(TimeSlot, GarageVisitPlace)) {
      return this.garageVisits.filter(gv => gv.TimeSlotId == TimeSlot.Id && gv.GaragePlaceId == GarageVisitPlace.GaragePlaceId && gv.DateId == this.helperService.GetDateId(this.currentDate))[0];
    }
  }

  public AddNewVisit(TimeSlot: GarageVisitsModels.GarageVisitsTimeSlotModel, GarageVisitPlace: GarageVisitsModels.GarageVisitsPlaceModel) {

    if (!this.newGarageVisit.CarTypeId) {
      this.displayMissingCarType = true;
      this.ScrollToCarType();
      return;
    }

    if (!GarageVisitPlace.PlaceTimeSlot.some(ts => ts.TimeSlot.Id == TimeSlot.Id)) {
      return;
    }



    if (this.helperService.GetDateId(this.currentDate) >= this.helperService.GetDateId(this.now) && this.IsTimeSlotFree(TimeSlot, GarageVisitPlace) && !TimeSlot.IsBlocked) {

      this.visitTimeSlot = TimeSlot;

      this.visitGarageVisitPlace = GarageVisitPlace;

      if (this.visitGarageVisitPlace && this.visitTimeSlot && this.currentDate) {

        if (this.newGarageVisit.IsTruck && !GarageVisitPlace.IsEnableTruck) {
          this.displayInvalidCarType = true;
          this.ScrollToCarType();
          return;
        }
        else {
          this.displayInvalidCarType = false;
        }


        let carTypeId: number = this.newGarageVisit.CarTypeId;

        this.newGarageVisit = new GarageVisitsModels.GarageVisitModel();
        this.newGarageVisit.CarTypeId = carTypeId;
        this.newGarageVisit.GaragePlaceId = this.visitGarageVisitPlace.GaragePlaceId;
        this.newGarageVisit.GaragePlaceName = this.visitGarageVisitPlace.Name;
        this.newGarageVisit.GaragePlaceIsEnableCar = this.visitGarageVisitPlace.IsEnableCar;
        this.newGarageVisit.GaragePlaceIsEnableTruck = this.visitGarageVisitPlace.IsEnableTruck;

        this.newGarageVisit.Date = new Date(Date.UTC(this.currentDate.getFullYear(), this.currentDate.getMonth(), this.currentDate.getDate(), this.visitTimeSlot.Hour, this.visitTimeSlot.Minutes));
        this.newGarageVisit.VisitDate = this.newGarageVisit.Date.getFullYear() + "-" + (this.currentDate.getMonth() + 1) + "-" + this.currentDate.getDate();
        this.newGarageVisit.TimeSlotId = this.visitTimeSlot.Id;
        this.newGarageVisit.TimeSlotLabel = this.visitTimeSlot.Label;

        this.currentStep = 1;

        this.ScrollToHeder();
      }
    }
  }

  public SetRowSpan(TimeSlot: GarageVisitsModels.GarageVisitsTimeSlotModel, GarageVisitPlace: GarageVisitsModels.GarageVisitsPlaceModel): number {

    if (this.garageVisits) {
      return this.garageVisits.some(gv => gv.TimeSlotId == TimeSlot.Id && gv.GaragePlaceId == GarageVisitPlace.GaragePlaceId && gv.DateId == this.helperService.GetDateId(this.currentDate) && gv.IsTruck === true) ? 2 : 1;
    }
    else {
      return null;
    }
  }

  public IsReservationValid(TimeSlot: GarageVisitsModels.GarageVisitsTimeSlotModel, GarageVisitPlace: GarageVisitsModels.GarageVisitsPlaceModel): boolean {

    if (TimeSlot.IsBlocked || this.helperService.GetDateId(this.currentDate) < this.helperService.GetDateId(this.now)) {
      return false;
    }
    else {
      return this.IsTimeSlotFree(TimeSlot, GarageVisitPlace);
    }
  }

  public IsDayBlocked(GivenDate: any): boolean {

    let isBlocked: boolean = false;

    let dateId = this.GetDateId(GivenDate);

    isBlocked = this.blockedDayList.some(bd => bd.DateId == dateId);

    if (!isBlocked) {
      let givenDate: Date = new Date(Date.UTC(GivenDate.year, GivenDate.month, GivenDate.day, 1, 0));

      let dayOfWeek = givenDate.getDay();

      if (dayOfWeek == 0) {

        isBlocked = !this.garageVisitPlaceList.Items.some(p => p.SundayOpenHour);
      }

      if (dayOfWeek == 6) {

        isBlocked = !this.garageVisitPlaceList.Items.some(p => p.SaturdayOpenHour);
      }
    }

    return isBlocked;
  }

  public onChangeCarTypeClick(CarType: CarTypeModels.CarTypeModel) {
    this.newGarageVisit.CarTypeId = CarType.CarTypeId;
    this.newGarageVisit.IsTruck = this.newGarageVisit.CarTypeId > 1;
    this.displayMissingCarType = false;
    this.displayInvalidCarType = false;
  }

  public onChangeVisitTyreSourceClick(VisitTyreSource: GarageVisitsModels.VisitTyreSourceModel) {
    this.newGarageVisit.VisitTyreSourceId = VisitTyreSource.VisitTyreSourceId;
    this.helperService.consoleLog("VisitTyreSourceId = " + this.newGarageVisit.VisitTyreSourceId);
  }

  public IsCarTypeValid(): boolean {

    return (this.newGarageVisit.IsTruck && this.newGarageVisit.GaragePlaceIsEnableTruck) || (!this.newGarageVisit.IsTruck && this.newGarageVisit.GaragePlaceIsEnableCar);
  }

  public onBack(): void {
    this.currentStep = 0;
    this.ScrollToHeder();
  }

  public onChangeGarageClick(): void {
    this.router.navigate(['/garage-select']);
  }

  localizationCalendarConfig = {
    firstDayOfWeek: 0,
    dayNames: [
      'Niedziela',
      'Poniedziałek',
      'Wtorek',
      'Środa',
      'Czwartek',
      'Piątek',
      'Sobota',
    ],
    dayNamesShort: ['Nie', 'Pon', 'Wto', 'Śro', 'Czw', 'Pią', 'Sob'],
    dayNamesMin: ['Nie', 'Pon', 'Wto', 'Śro', 'Czw', 'Pią', 'Sob'],
    monthNames: [
      'Styczeń',
      'Luty',
      'Marzec',
      'Kwiecień',
      'Maj',
      'Czerwiec',
      'Lipiec',
      'Sierpień',
      'Wrzesień',
      'Październik',
      'Listopad',
      'Grudzień',
    ],
    monthNamesShort: [
      'Sty',
      'Lut',
      'Mar',
      'Kwi',
      'Maj',
      'Cze',
      'Lip',
      'Sie',
      'Wrz',
      'Paź',
      'Lis',
      'Gru',
    ],
    today: 'Dzisiaj',
    clear: 'Wyczyść',
    dateFormat: 'dd.mm.yy',
    weekHeader: 'Tyg',
  };

  public IsFormProcessing(): boolean {
    return this.requestGarageVisitSave.IsProcessing || this.carCheckRequest.IsProcessing;
  }

  public onGoToALD() {
    window.location.href = 'https://wymianaopon.point-s.pl';
  }

  private ScrollToCarType() {

    if (this.divCarType) {
      this.divCarType.nativeElement.scrollIntoView({ behavior: 'smooth' });
    }
  }

  private ScrollToHeder() {

    if (this.divHeder) {
      this.divHeder.nativeElement.scrollIntoView({ behavior: 'smooth' });
    }
  }

  public onChangeGarateClick(Garage: GarageModels.GaragePreviewModel) {

    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    }
    this.router.onSameUrlNavigation = 'reload';

    this.router.navigate(['/garage-visit', Garage.GarageId]);
  }
}
